import {getCurrentTime} from 'shared/utils/dateTime';
import {RecordKind} from '../const';

export function createFactoryFor(type: RecordEntryKind): RecordFactory {
  return function createRecord(amount: MoneyAmount): RecordEntry {
    const record: RecordEntry = {
      dateTime: getCurrentTime(),
      amount,
      type,
    };

    if (type === RecordKind.Income) {
      record.excludeFromBudget = true;
    }

    return record;
  };
}
